<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12" class="ml-auto mr-auto d-flex align-center justify-center">
        <v-row no-gutters class="align-start">
          <SubscriptionInfo></SubscriptionInfo>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import {mapState, mapActions} from 'vuex';
import SubscriptionInfo from "../components/Subscriptions/SubscriptionInfo";

export default {
  name: "SubscriptionMain",
  components: {SubscriptionInfo},

  computed: {
    ...mapState('getSubscription', {
      dataSubscription: state => state.dataSubscription
    }),
    ...mapState('getCompanyUser', {
      user: state => state.dataReceive
    }),
  },
  methods: {
    ...mapActions("getCompanyUser", ["getCompanyUser"]),
    ...mapActions("getSubscription", ["getSubscriptionData"]),

  },
  mounted() {
    this.getCompanyUser();
    this.updateLanguage(this.getCurrentLanguage);


  },

}
</script>

